import InputAdornment from "@mui/material/InputAdornment";
import { stripPhonePrefix } from "code/formatHelpers";
import TextInput, { TextInputProps } from "components/TextInput";
import { DEFAULT_PHONE_CODE } from "constants/CountryCodes";

type PhoneInputProps = Omit<TextInputProps, "value" | "onChange" | "slotProps"> & {
	value?: string | null;
	onChange: (value: string) => void;
};

export default function PhoneInput({ value, onChange, ...props }: PhoneInputProps) {
	const handleChange = (val: string) => {
		const sanitised = val.replace(/[^+0-9\s\-(). ]/g, "");
		const withoutKnownPrefix = stripPhonePrefix(sanitised);
		// Strip any remaining country prefix (e.g. user pasted +61... or +1...)
		// The +64 adornment is already shown, so the field value should never start with +
		const cleaned = withoutKnownPrefix.replace(/^\+/, "");
		onChange(cleaned);
	};

	return (
		<TextInput
			{...props}
			value={stripPhonePrefix(value)}
			onChange={handleChange}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position="start" disableTypography>
							{DEFAULT_PHONE_CODE}
						</InputAdornment>
					)
				},
				htmlInput: { type: "tel" }
			}}
		/>
	);
}
